import React from 'react';
import PropTypes from 'prop-types';

import {greyishBlue900} from "assets/jss/main";
import {ReactComponent as LocationIcon} from "assets/img/location-contained.svg";

InventoryName.propTypes = {
    name: PropTypes.string.isRequired,
    noIcon: PropTypes.bool
};

function InventoryName({name, noIcon = false}) {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center'
        }}>
            {!noIcon && <LocationIcon />}
            <span style={{
                fontSize: '14px',
                fontWeight: 600,
                color: greyishBlue900,
                marginLeft: noIcon ? '0px' : '8px'
            }}>
                {name}
            </span>
        </div>
    );
}

export default InventoryName;
